<template>
    <div class="errLocationDialog-component">
        <van-dialog v-model="show" theme="round" :showConfirmButton="false" :showCancelButton="false">
            <template #default>
                <div>
                    <div class="title"><span></span><i class="ico ico-icon_02" @click="close()"></i></div>
                    <div class="tips">获取位置失败，请刷新定位</div>
                    <div class="btn-group">
                        <div class="btn" @click="refresh()"><i class="ico ico-icon_102"></i>刷新</div>
                        <div class="btn submit" @click="search()"><i class="ico ico-icon_103"></i>搜索门店</div>
                    </div>
                </div>
            </template>
        </van-dialog>
    </div>
</template>
<script>
import { Dialog } from 'vant'
import { throttle } from 'lodash'
export default {
    name: 'errLocationDialog',
    components: {
        [Dialog.name]: Dialog
    },
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            show: false,
        }
    },
    watch: {
        reason: throttle(function (newValue) {
            this.reason = newValue.slice(0, 30)
        }, 100)
    },
    methods: {
        close () {
            this.show = false
        },
        refresh () {
            this.show = false
            location.reload()
        },
        search () {
            this.$emit('changeStoreList')
        }
    }
}
</script>
<style lang="stylus">
    .errLocationDialog-component
        .van-dialog
            border-radius 16px !important
            .van-dialog__content
                .title
                    display flex
                    justify-content space-between
                    align-items center
                    padding  0 30px
                    height 88px
                    span
                        display inline-block
                        position relative
                        font-size $font34
                        color $inputTextColor
                .tips
                    width 100%
                    color $fcGrey
                    font-size $fontBase
                    text-align center
                    margin 20px 0 80px
                .btn-group
                    display flex
                    justify-content space-between
                    padding 36px 50px
                    .btn
                        box-sizing border-box
                        width 260px
                        height 88px
                        line-height 88px
                        text-align center
                        border-radius 44px
                        border 1px solid #DCDCDC
                        color #FC2D2D
                        display flex
                        justify-content center
                        align-items center
                        font-size $font34
                        &.submit
                            color $fcWhite
                            border none
                            background linear-gradient(90deg, #FF5442, #FC2D2D)
</style>
